import React, { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom';
import { DepartmentTableColumns } from '../../../datatablesource';
import newRequest from '../../../utils/newRequest';
import Datatable from '../../datatable/Datatable';
import "./department.scss";
import { handleError, handleSuccess } from '../../../utils/error';
import { useTranslation } from "react-i18next";

export const Department = () => {
  const navigate = useNavigate();
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [isAuthenticating, setIsAuthenticating] = useState(true);
  const { t, i18n } = useTranslation();
  const [departmentList, setDepartmentList] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  const fetchDepartment = async () => {
    const response = await newRequest.get("/GetAllNewDepartmentLit");
    setDepartmentList(response?.data ?? []);
  };

  useEffect(() => {
    setIsLoading(true);
    const getDepartment = async () => {
      try {
        await fetchDepartment();
        setIsAuthenticated(true);
        setIsAuthenticating(false);
        handleSuccess();
        setIsLoading(false);
      }
      catch (error) {
        handleError(error);
        setIsAuthenticated(false);
        setIsAuthenticating(false);
        setIsLoading(false);
      }
    };
    getDepartment();
  }, []);


  return (
    <>
      {isAuthenticating ? (
        <div>{t("Loading")}...</div>
      ) : isAuthenticated ? (
        <div>
          <Datatable
            secondaryColor="secondary"
            columnsName={DepartmentTableColumns(t)}
            loading={isLoading}
            data={departmentList}
            title={t("DEPARTMENTS")}
            uniqueId="departmentId"
            addNewNavigation="/admin/database-config/department/add-new"
            deleteBtnEndPoint="/DeleteNewDepartmentLitById"
            checkboxSelectionOption={false}
            onImportSuccess={fetchDepartment}
          />
        </div>
      ) : (
        <div className="text-center text-red-500">
          {t("Not authenticated")}
        </div>
      )}
    </>
  );

}
